export const bulkNotificationsKeys = {
  all: ["bulk-notifications"] as const,
  campaigns: () => [...bulkNotificationsKeys.all, "campaigns"] as const,
  campaign: (id: string) => [...bulkNotificationsKeys.all, "campaign", id] as const,
  dispatches: (campaignId: string) =>
    [...bulkNotificationsKeys.all, "dispatches", campaignId] as const,
};
